import { Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLanguage } from "@/i18n/LanguageContext";

export const FavoriteButton = ({ item, itemType, inline = false, className = "" }) => {
  const { isFavorite, toggleFavorite } = useAuth();
  const { t } = useLanguage();
  const fav = isFavorite(itemType, item.slug);

  const base = inline
    ? "p-1.5 text-slate-300 transition hover:text-red-400"
    : "rounded-full bg-white/90 p-2 shadow-sm backdrop-blur transition hover:scale-110 hover:bg-white";

  return (
    <button
      type="button"
      data-testid={`favorite-button-${item.slug}`}
      aria-label={fav ? t("Retirer des favoris") : t("Ajouter aux favoris")}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(itemType, item);
      }}
      className={`${base} ${className}`}
    >
      <Heart className={`h-4 w-4 transition ${fav ? "fill-red-500 text-red-500" : inline ? "" : "text-slate-600"}`} />
    </button>
  );
};
